module.exports = __webpack_public_path__ + "e93e6e803800973cd72efbcc5fd6f617.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/large-2.png
// module id = 2099
// module chunks = 0